/* unplugin-vue-components disabled */import { render } from "./DeviceImei.vue?vue&type=template&id=3d982796&scoped=true"
import script from "./DeviceImei.vue?vue&type=script&lang=js"
export * from "./DeviceImei.vue?vue&type=script&lang=js"

import "./DeviceImei.vue?vue&type=style&index=0&id=3d982796&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d982796"]])

export default __exports__